import { Request } from '../codegen/graphql';

export const STATUS_MAPPER = {
    Created: 'New Request',
    PendingSupplier: 'Pending',
    Pending: 'Pending',
    ApprovedSupplier: 'Interim Price',
    Approved: 'Approved',
    Declined: 'Declined',
    default: 'New Request',
};

export function isPricingRequestUrgent(request: Request): boolean {
    return (
        (new Date(request.dueBy).getTime() - new Date().getTime()) /
            (1000 * 60 * 60) <=
            4 && !request.completed
    );
}

export function getPricingRequestStatusLabel(request: Request): string {
    if (isPricingRequestUrgent(request)) {
        return 'Urgent';
    }
    if (request.isAutoDeclined) {
        return 'Auto-declined';
    }
    return (
        STATUS_MAPPER[request.latestStatus as keyof typeof STATUS_MAPPER] ||
        STATUS_MAPPER.default
    );
}
